import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { ReportTemplateQuery } from "@/features/Reports/new/graphql";
import { PreviewReport } from "@/features/Reports/new/PreviewReport";
import { WizardPage } from "@/features/Reports/new/WizardPage";

const searchSchema = z.object({
  responseIds: z.array(z.string()).default([]),
});

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/reports/new/$reportTemplateId/preview",
)({
  validateSearch: zodValidator(searchSchema),
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationKey, reportTemplateId } = Route.useParams();
  const { responseIds } = Route.useSearch();
  const { data } = useSuspenseQuery(ReportTemplateQuery, {
    variables: { organizationKey, reportTemplateId },
  });

  return (
    <WizardPage step="preview" reportTemplateId={reportTemplateId} responseIds={responseIds}>
      <PreviewReport
        key={`${reportTemplateId}-${responseIds.join(",")}`}
        template={data.organization.reportTemplate}
        responseIds={responseIds}
      />
    </WizardPage>
  );
}
